import React from 'react';

const Tour = () => {
  const tourDates = [
    {
      id: 1,
      location: "Luna May Day Gathering and Bazaar",
      date: "May 2, 2026",
      time: "2:00 PM",
      spot: "Potter Street, Berkeley",
      description: "We'll be performing and then teaching steps to the audience! Join us for Luna's May Day Gathering & Bazaar - a free, family-centered, outdoor street celebration in front of Luna's new building in Southwest Berkeley. Along with small business booths, Luna will offer interactive creative dance and arts activities for the community.",
      status: "upcoming",
      mapUrl: "https://maps.app.goo.gl/PotterStreetBerkeley",
      image: "/locations/lunabazaar.jpg"
    },
  ];

  const pastPerformances: Array<{
    location: string;
    date: string;
    description: string;
    videoUrl?: string;
    image?: string;
  }> = [
    {
      location: "Lytton Plaza",
      date: "April 24, 2026",
      description: "5-minute spontaneous flash mob! We attracted passers-by with great music and dance, then disappeared into the crowd. Pure Bollywood-HipHop fusion magic!",
      videoUrl: "https://www.youtube.com/embed/FvrPFI-l9WI",
      image: "/locations/lyttonplaza.jpg"
    }
  ];

  return (
    <section id="tour" className="py-20 bg-light-cyan">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text-dark mb-4" style={{textShadow: '0 2px 20px rgba(0,0,80,.2)'}}>
            Bay Area <span 
              style={{
                background: 'linear-gradient(90deg, #FC9C24, #E454B4, #5454B4, #0C9CCC)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >Flash Mob Tour</span>
          </h2>
          <p className="text-xl text-text-dark max-w-3xl mx-auto opacity-88">
            Catch us surprising crowds across the Bay Area! All performances are free and open to everyone.
          </p>
          <div className="w-24 h-1 mx-auto mt-4" style={{
            background: 'linear-gradient(90deg, #FC9C24, #E454B4, #5454B4, #0C9CCC)'
          }}></div>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-bold text-text-dark mb-8 text-center">Upcoming Performances</h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tourDates.map((event) => (
              <div
                key={event.id}
                className="bg-white border border-cyan-bright/30 rounded-xl p-6 card-hover"
              >
                {event.image && (
                  <div className="mb-6 -mt-6 -mx-6">
                    <img 
                      src={event.image} 
                      alt={event.location}
                      className="w-full h-48 object-cover rounded-t-xl"
                    />
                  </div>
                )}
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h4 className="text-xl font-semibold text-text-dark">{event.location}</h4>
                    <p className="text-electric-cyan font-medium">{event.date}</p>
                  </div>
                  <span className="px-3 py-1 text-sm rounded-full" 
                    style={{
                      background: 'rgba(255,255,255,.25)',
                      color: 'white',
                      border: '1px solid rgba(255,255,255,.4)'
                    }}>
                    Upcoming
                  </span>
                </div>
                
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-text-dark opacity-70">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {event.time}
                  </div>
                  <div className="flex items-center text-text-dark opacity-70">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {event.spot}
                  </div>
                </div>
                
                
                <div className="mt-4 pt-4 border-t border-cyan-bright/30">
                  <p className="text-text-dark opacity-70 mb-4">{event.description}</p>
                  <div className="mb-4">
                    <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3150.366520497089!2d-122.2902993!3d37.8517136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80857ef50538465d%3A0x2edd2404276c277b!2s930-978%20Potter%20St%2C%20Berkeley%2C%20CA%2094710!5e0!3m2!1sen!2sus!4v1777412697045!5m2!1sen!2sus" 
                      width="100%" 
                      height="200" 
                      style={{ border: 0 }} 
                      allowFullScreen={true} 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Luna May Day Gathering Location Map"
                      className="rounded-lg"
                    ></iframe>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {pastPerformances.length > 0 && (
          <div className="bg-light-pink rounded-2xl p-8 mt-16">
            <h3 className="text-2xl font-bold text-text-dark mb-8 text-center">Past Performances</h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {pastPerformances.map((performance, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded-lg border border-hot-pink/30"
                >
                  {performance.image && (
                    <div className="mb-4">
                      <img 
                        src={performance.image} 
                        alt={performance.location}
                        className="w-full h-40 object-cover rounded-lg"
                      />
                    </div>
                  )}
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <h4 className="text-lg font-semibold text-text-dark">{performance.location}</h4>
                      <p className="text-text-dark opacity-70">{performance.date}</p>
                    </div>
                    <span className="px-3 py-1 text-sm rounded-full" 
                      style={{
                        background: '#FCCC54',
                        color: '#5454B4'
                      }}>
                      Completed
                    </span>
                  </div>
                  
                  <p className="text-text-dark opacity-80">{performance.description}</p>
                  {performance.videoUrl && (
                    <div className="mt-4">
                      <iframe 
                        src={performance.videoUrl}
                        width="100%" 
                        height="315" 
                        style={{ border: 0 }} 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                        title={`${performance.location} Performance Video`}
                        className="rounded-lg"
                      ></iframe>
                    </div>
                  )}
                  <div className="mt-4">
                    <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3167.681050721502!2d-122.1625267832658!3d37.44463882156299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fbb39f0910295%3A0x3cc86a348c801abc!2sLytton%20Plaza!5e0!3m2!1sen!2sus!4v1775881341570!5m2!1sen!2sus" 
                      width="100%" 
                      height="150" 
                      style={{ border: 0 }} 
                      allowFullScreen={true} 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${performance.location} Location Map`}
                      className="rounded-lg"
                    ></iframe>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Tour;
